import { ToastProvider } from '@talentbabu/ui';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { useEffect, useState, type ReactNode } from 'react';
import { refreshSession } from '../lib/api';

function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        // Never retry client errors (401/403/404/422); retry transient failures twice.
        retry: (count, err) => !(isAxiosError(err) && err.response && err.response.status < 500) && count < 2,
      },
    },
  });
}

/** Restores the session from the httpOnly refresh cookie once on load. */
function SessionBootstrap({ children }: { children: ReactNode }) {
  useEffect(() => {
    void refreshSession();
  }, []);
  return <>{children}</>;
}

export function AppProviders({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createQueryClient);
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <SessionBootstrap>{children}</SessionBootstrap>
      </ToastProvider>
    </QueryClientProvider>
  );
}
